import React, { useState } from 'react'
import { Modal } from '../ui/Modal'
import { useAuth } from '../auth/AuthContext'
import { Checkbox } from '../ui/Checkbox'
import { Button } from '../ui/Button'
import { toast } from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

const AcceptTermsConditionsModal = () => {
  const { acceptTerms, acceptPrivacy, user, logout, mustChangePassword } =
    useAuth()
  const { requiresTermsAcceptance, requiresPrivacyAcceptance } = user || {}
  const [checked, setChecked] = useState(false)
  const navigate = useNavigate()

  console.log(requiresPrivacyAcceptance, requiresTermsAcceptance)

  const handleModalClose = () => {
    toast.success('Términos y condiciones aceptados')
  }

  const handleTermsPrivacyAcceptance = async () => {
    try {
      if (requiresTermsAcceptance) {
        await acceptTerms()
      }

      if (requiresPrivacyAcceptance) {
        await acceptPrivacy()
      }

      setChecked(false)
      // handleModalClose()
    } catch (error) {
      console.error('Error accepting terms/privacy:', error)
      toast.error('Error al aceptar términos y condiciones')
    }
  }

  const handleGoBack = () => {
    logout()
    setChecked(false)
    navigate('/login')
  }

  // Determinar el texto del checkbox basado en qué se requiere aceptar
  const getCheckboxLabel = () => {
    if (requiresTermsAcceptance && requiresPrivacyAcceptance) {
      return (
        <span className="text-base">
          Acepto los{' '}
          <a
            href="https://oautos.com.mx/terminos-y-condiciones-a"
            target="_blank"
            rel="noopener noreferrer"
            className="text-olr-primary underline"
          >
            Términos y Condiciones
          </a>{' '}
          y el{' '}
          <a
            href="https://oautos.com.mx/aviso-de-privacidad-a"
            target="_blank"
            rel="noopener noreferrer"
            className="text-olr-primary underline"
          >
            Aviso de Privacidad
          </a>
        </span>
      )
    } else if (requiresTermsAcceptance) {
      return (
        <span className="text-base">
          Acepto los{' '}
          <a
            href="https://oautos.com.mx/terminos-y-condiciones-a"
            target="_blank"
            rel="noopener noreferrer"
            className="text-olr-primary underline"
          >
            Términos y Condiciones
          </a>
        </span>
      )
    } else if (requiresPrivacyAcceptance) {
      return (
        <span className="text-base">
          Acepto el{' '}
          <a
            href="https://oautos.com.mx/aviso-de-privacidad-a"
            target="_blank"
            rel="noopener noreferrer"
            className="text-olr-primary underline"
          >
            Aviso de Privacidad
          </a>
        </span>
      )
    }
    return null
  }

  return (
    <Modal
      isOpen={
        (requiresTermsAcceptance! || requiresPrivacyAcceptance!) &&
        !mustChangePassword
      }
      onClose={handleModalClose}
      size="sm"
      closeOnOverlay={false}
    >
      <div className="p-8 text-center">
        <div className="mb-8 max-w-4xl mx-auto">
          <Checkbox
            checked={checked}
            onChange={e => setChecked(e.target.checked)}
            label={getCheckboxLabel()}
          />
        </div>

        <div className="space-y-3">
          <Button
            variant="primary"
            onClick={handleTermsPrivacyAcceptance}
            className="w-full"
            disabled={!checked}
          >
            {'Acepto'}
          </Button>
          <Button variant="secondary" onClick={handleGoBack} className="w-full">
            Volver
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default AcceptTermsConditionsModal
